import "./footer.scss";

export default function Footer() {
  return <footer>Made by Tuan Le</footer>;
}
